import { Component, Input, OnInit } from '@angular/core';
import { UploadFilesService } from '../../../_services/upload-files.service';
import { HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { FidelidadeService } from 'src/app/modules/_services/fidelidade.service';
import { map } from 'rxjs/operators';
import { Imagem } from 'src/app/modules/_models/imagem';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageCroppedEvent, base64ToFile } from 'ngx-image-cropper';

@Component({
  selector: 'app-upload-files',
  templateUrl: './upload-files.component.html',
  styleUrls: ['./upload-files.component.scss'],
})
export class UploadFilesComponent implements OnInit {
  selectedFile: File;
  fileCropper: File;

  @Input('imagem') imagem;
  @Input('imagemMembro') imagemMembro;

  progressInfo;
  message = '';
  url;
  imagemProfile: Observable<Imagem>;

  fileInfos: Observable<any>;
  arquivosEmProcessamento = 0;
  arquivos = [];

  arquivoUpload: boolean = false;
  confirmarEnvio: boolean = false;

  constructor(private uploadService: UploadFilesService, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.arquivoUpload = false;

    if (this.imagemMembro) {
      this.uploadService.getPhotoProfile().subscribe((res) => { if (res != null) { this.url = res.base64 } });
    }
  }

  selectFiles(event): void {
    this.progressInfo = { value: 0, fileName: '' };
    this.selectedFile = event.target.files[0];
    this.arquivoUpload = false;
    this.message = '';
    this.uploadFiles(this.imagem);
  }

  upload(file): void {
    this.uploadService.upload(file).subscribe(
      (event) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progressInfo.fileName = file.name;
          this.progressInfo.value = Math.round(
            (100 * event.loaded) / event.total
          );
        } else if (event.type === HttpEventType.Response) {
          this.progressInfo.fileName = file.name;
          this.progressInfo.value = 100;
          this.arquivoUpload = false;
          this.confirmarEnvio = false;
          this.uploadService.getPhotoProfile().subscribe((res) => { if (res != null) { this.url = res.base64 } });

          // Swal.fire({
          //   title: 'Atenção!',
          //   text: 'Imagem de perfil alterada com sucesso!',
          //   icon: 'success',
          //   confirmButtonColor: '#2d1708',
          //   confirmButtonText: 'Ok',
          // }).then();
          // {
          //   return;
          // }
        }
      },
      (err) => {
        this.progressInfo.value = 0;
        this.message =
          'Não foi possível fazer o upload do arquivo:' + file.name;
      }
    );
  }

  uploadFiles(imagem: boolean): void {
    this.message = '';
    this.confirmarEnvio = false;

    //Valida arquivo
    if (imagem) {
      if (
        this.selectedFile.type != 'image/png' &&
        this.selectedFile.type != 'image/jpeg'
      ) {
        Swal.fire({
          title: 'Atenção!',
          text: 'Apenas arquivos de imagens no formato jpeg ou png são aceitos',
          icon: 'warning',
          confirmButtonColor: '#2d1708',
          confirmButtonText: 'Ok',
        }).then();
        {
          return;
        }
      }

      const reader = new FileReader();
      reader.readAsDataURL(this.selectedFile);
      reader.onload = (_event) => {
        this.url = reader.result;
      };

      this.arquivoUpload = true;
    }
  }

  confirmar() {
    this.upload(this.fileCropper);
  }

  transform(base64Image: string) {
    if (this.arquivoUpload)
      return this.url;

    return this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpeg;base64,' + base64Image);
  }

  async imageCropped(event: ImageCroppedEvent) {
    const res: Response = await fetch(event.base64);
    const blob: Blob = await res.blob();

    var fileName = this.selectedFile.name;

    var file = new File([blob], fileName, { type: 'image/jpeg' });
    this.fileCropper = file;

    if (this.fileCropper.size / 1024 / 1024 > 1) {
      Swal.fire({
        title: 'Atenção!',
        text: 'O arquivo deve ter o tamanho máximo de 1 mega!',
        icon: 'warning',
        confirmButtonColor: '#2d1708',
        confirmButtonText: 'Ok',
      }).then();
      {
        return;
      }
    }

    this.confirmarEnvio = true;
  }
}
